export const RememberMeKey = "SRM_Purchasing_RememberMe";
export const VerificationCodeCountDownKey =
  "SRM_Purchasing_VerificationCodeCountDown";
